<template>
    <div class="comment-list" v-if="data.length">
        <div class="sub-title">课程评价</div>
        <div class="starBox">
            <span class="score">{{ avgScore }}</span>
            <div class="stars">
                <img
                    v-for="(item, index) in 5"
                    :key="index"
                    class="star"
                    :src="item <= avgScore ? StarActive : Star"
                />
            </div>
        </div>
        <div class="all-comment">
            <span>全部评论</span>
            <img class="arrow-down" src="~@/assets/arrow-down.png" alt="" />
        </div>
        <div class="list">
            <div class="item" :id="item.id" v-for="item in data" :key="item.id">
                <div class="left">
                    <img class="headImg" :src="item.avatarUrl" alt="" />
                </div>
                <div class="right">
                    <div class="nickname">{{ item.name }}</div>
                    <!-- <div class="stars">
                        <img
                            v-for="(item2, index) in 5"
                            :key="index"
                            class="star"
                            :src="item2 <= item.score ? StarActive : Star"
                        />
                    </div> -->
                    <div class="content">
                        {{ item.content }}
                    </div>
                    <div class="footer">
                        <span class="time">{{ item.createTime }}</span>
                        <div class="right" v-if="isClick">
                            <div
                                class="childrenCommnet"
                                @click="
                                    addChildComment(item.clssifyforId, item.id)
                                "
                            >
                                <img
                                    class="commentLogo"
                                    src="~@/assets/comment-logo.png"
                                    alt=""
                                />
                                <span>{{ item.childrenList.length }}</span>
                            </div>
                            <div
                                class="thumbBox"
                                :class="{ active: item.ifMyLike }"
                                @click="likeComment(item.ifMyLike, item.id)"
                            >
                                <img
                                    v-if="item.ifMyLike"
                                    class="thumb"
                                    src="~@/assets/thumb-active.png"
                                    alt=""
                                />
                                <img
                                    v-else
                                    class="thumb"
                                    src="~@/assets/thumb.png"
                                    alt=""
                                />
                                <span class="thumbNum">{{ item.likeNum }}</span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="reply"
                        v-for="child in item.childrenList"
                        :id="child.id"
                        :key="child.id"
                        v-html="child.name + '回复' + child.content"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Star from "../../assets/star.png";
    import StarActive from "../../assets/star-active.png";
    import commentService from "../../service/comment.service";
    export default {
        name: "comment-list",
        props: ["data", "avgScore", "isClick", "disabled"],
        data() {
            return {
                Star,
                StarActive,
                loading: false,
            };
        },
        methods: {
            likeComment(ifMyLike, id) {
                if (this.loading) {
                    return;
                }
                this.loading = true;
                if (ifMyLike) {
                    return;
                }
                commentService
                    .likeComment({ id })
                    .then(() => {
                        this.$emit("update");
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            },
            addChildComment(clssifyforId, parentId) {
                this.$router.push({
                    path: `/comment/${clssifyforId}`,
                    query: { parentId },
                });
            },
        },
    };
</script>

<style lang="scss" scoped src="./comment-list.scss"></style>
